<template>
    <div v-loading="isSuccess">
        <div class="PaperInfo">
            <img class="imgBanner" :src="infoData.coverurl" alt="">
            <div class="paperInfo">
                <p>{{infoData.subject}}</p>
                <p>已有{{infoData.usecount}}人参与</p>
            </div>
            <div class="examination_box">
                <div class="flex_info">
                    <p>答题数目：<b>{{infoData.quescount}}道</b></p>
                    <p>试卷总分：<b>{{infoData.examtotalscore}}</b></p>
                </div>
                <div class="flex_info">
                    <p>考试时长：<b>{{infoData.examlength===0?'不限制':infoData.examlength+'分钟'}}</b></p>
                    <p>可考次数：<b>{{infoData.examcount===0?'不限制':infoData.examcount+'次'}}</b></p>
                </div>
                <div>
                    <p>提供机构：<b>{{infoData.hostname}}</b></p>
                </div>
            </div>
            <footer>
                <van-button type="primary" @click="goExam" v-if="infoData.status===0">进入考试</van-button>
                <van-button type="primary" @click="goExam" v-if="infoData.status===1">继续考试</van-button>
                <van-button type="primary" @click="seeAchievement" v-if="infoData.status===10">查看成绩</van-button>
                <div class="footer_flex" v-if="infoData.status===11">
                    <van-button type="primary" @click="seeAchievement">查看成绩</van-button>
                    <van-button type="primary" @click="goExam" class="footer_noSame">重新考试</van-button>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
    import {getExampaperDetail,updateStartExam} from 'api/questionbank'
    import {mapGetters,mapActions} from 'vuex'
    export default {
        name: "PaperInfo",
        data(){
            return{
                isSuccess:true, //数据是否加载完成
                infoData:{}
            }
        },
        activated () {
            if (this.refresh) {
                this._getInfo();
                this.setRefresh(false)
            }
        },
        mounted(){
            if (!this.refresh) {
                this._getInfo();
            }
        },
        methods:{
            _getInfo(){
                this.setLoading(true);
                let params = {
                    bankid: this.$route.query.bankid,
                    taskid: this.$route.query.taskid //只有系列试卷才有，单试卷可不传
                };
                getExampaperDetail({
                    data: Object.assign({}, params),
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.setRefresh(true)
                        this.isSuccess=false;
                        this.infoData = data.data;
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            //进入考试/继续考试/重新考试（继续考试需要id）
            goExam(){
                this.setLoading(true);
                let params = {
                    assetinnerid: this.$route.query.bankid,
                    taskid: this.$route.query.taskid?this.$route.query.taskid:0, //只有系列试卷才有，单试卷0
                    examid:this.infoData.status===1?this.infoData.userexaminnerid:'',
                };
                updateStartExam({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        this.setRefresh(true);
                        this.$router.push({name: 'MExamView',query: {examid:data.msg}})
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            //继续考试
            // continueExam(){
            //     this.setRefresh(true)
            //     this.$router.push({name: 'MExamView',query: {examid:this.infoData.userexaminnerid}})
            // },
            //查看成绩
            seeAchievement(){
                this.setRefresh(true);
                this.$router.push({name: 'MExamResult',query: {exampid:this.infoData.userexaminnerid}})
            },
            ...mapActions([
                'setLoading',
                'setRefresh'
            ])
        },
        computed: {
            ...mapGetters(['refresh'])
        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .PaperInfo{
        .imgBanner{
            width: 100%;
            height: 4.22rem;
            background: #eee;
        }
        .paperInfo{
            background: #fff;
            padding: 0.24rem 0.32rem;
            margin-bottom: 0.2rem;
            p{
                font-size: 0.24rem;
                color: #666;
            }
            p:first-child{
                line-height: 0.45rem;
                font-size: 0.32rem;
                margin-bottom: 0.2rem;
                font-weight: bold;
            }
        }
        .examination_box{
            background: #fff;
            padding: 0.32rem;
            div{
                display: flex;
                justify-content: space-between;
                p{
                    font-size: 0.28rem;
                    color: #999;
                    line-height: 0.4rem;
                    flex: 1;
                    b{
                        color: #333;
                    }
                }
            }
            .flex_info{
                margin-bottom: 0.2rem;
                p:last-child{
                    padding-left: 2rem;
                }
            }
        }
        footer{
            position: fixed;
            bottom: 0;
            height: 1rem;
            background-color: #ffffff;
            width: 100vw;
            display: flex;
            align-items: center;
            border-top: 0.01333rem solid #f0eeee;
            box-sizing: border-box;
            .van-button{
                background: linear-gradient(180deg, #40c7ff 0%, #409eff 100%);
                width: 100%;
                height: 0.76rem;
                line-height: 0.76rem;
                border-radius: 0.38rem;
                font-size: 0.3rem;
                border: none;
                display: flex;
                justify-content: center;
                margin: 0 0.32rem;
            }
            .footer_flex{
                width: 100%;
                display: flex;
                .footer_noSame{
                    background:rgba(230,241,252,1);
                    border:0.01rem solid rgba(64,158,255,1);
                    color: #409EFF;
                }
            }
        }
    }
</style>